module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_07@2x-94995eb546dc11318ae7dcd90ca9136b.jpg";